import axios from 'axios'

export default class GerenciamentoToken {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/tokenAplicacao`
    this.tokenBearer = tokenBearer
  }

  async getAplicacoes () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/listarAplicacoes`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getConsultaAplicacao (args = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async postTokenAplicacao (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'post',
        url: `${this.url}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async putInvalidarToken (tokenId) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.url}/invalidar/${tokenId}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async putAtualizarToken (data, tokenId) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.url}/atualizar/${tokenId}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async putRefreshToken (tokenId) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url: `${this.url}/refreshToken/${tokenId}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
